import { OwnerByEnum, ILabelKey, IColumnType } from '../../services/eleview/types/model';
import { ConditionalTemplate } from '../../element/service/recordview-param';
export interface TableColumnType extends IColumnType {
	/**éå çå±æ§ï¼ç¨äºå®¢æ·ç«¯ */
	index: number;
	sticky: boolean;
	stickyEnd: boolean;
	showToolbar: boolean;
}
export enum Order {
	// OrderAsc ååº
	OrderAsc = '+',
	// OrderDesc éåº
	OrderDesc = '-',
	// OrderNone æ æåº
	OrderNone = ''
}
export enum SelectType {
	Selected = 's',
	Unselected = 'ns'
}

export interface ConditionalValue {
	Type: string;
	Field: string;
	Value: any;
}
export interface RangeInputConditionalValue {
	LowValue: string;
	HighValue: string;
}
export interface SelectConditionalValue {
	Value: string;
	OtherOption: string;
	Options: string[];
}
export interface MultiSelectConditionalValue {
	Value: string[];
	OtherOption: string;
	Options: string[];
}
export interface SliderConditionalValue {
	LowValue: number;
	HighValue: number;
	PositiveInfinity: boolean; // æ­£æ ç©·
	NegativeInfinity: boolean; // è´æ ç©·
	Ratio: number;
}
export interface IFetchDataParam {
	/**åéè¡çä¸»é®å¼*/
	Divide?: Array<string>;
	/**æåºçå­æ®µï¼ååºåªå¡«å­æ®µåï¼éåºå­æ®µååå -ï¼åå·ï¼*/
	Order?: Array<string>;
	/**å­æ®µ*/
	Field?: string;
	/**è¿ç®ç¬¦*/
	Opt?: string;
	/**å¼*/
	Value?: string;
	/**éæ©ç±»å*/
	SelType?: string;
	/**éæ©çä¸»é®*/
	SelKeys?: Array<string>;
	/**æ¯é¡µæå¤è¡æ°*/
	Limit?: number;
	/**å¼å§è¡å·*/
	DivideRowNum?: number;
	// åºç¨çæ ç­¾ID
	Labels?: ILabelKey[];
	// æ¾ç¤ºåçæ¨¡æ¿
	View?: IElementViewDigest;
	// æ¡ä»¶æ¨¡æ¿çè®¾ç½®åæ°
	ConditionalTemplate?: ConditionalValue[];
}
export interface IFetchRowCountResult {
	RowCount: number;
}
export interface IFetchDataResultType {
	Error: string;
	FData: IFetchDataResult;
}
export interface IFetchDataResult {
	Title: string;
	Rows: Array<IRenderRow>;
	Columns: Array<IColumnType>;
	DisplayColumns: Array<IColumnType>;
	/**ä¸è¬ä¸º0ï¼é¤éæåä¸é¡µï¼éè¿æåçåºå·å¾åºæ»æ° */
	RowCount: number;
	/**ä¸ä¸é¡µç¨å°çèµ·å§åºå· */
	DownRowNum: number;
	/**ä¸ä¸é¡µç¨å°çèµ·å§åçå¼ */
	DownDivide: string[];
	/**éç»å®è®°å½çå¤çæé®çå¯ç¨æ§ */
	Processes: { [key: string]: IRenderProcess };
}
// æ¯æ¬¡æ¥è¯¢æ¶è¿åçåä¸ªprocessçéå ä¿¡æ¯
export interface IRenderProcess {
	URL: string;
	Sign: string;
	Enabled: boolean;
}
export interface IRenderRow {
	RowNum: number;
	/**æ¯å¦è¢«éä¸­ */
	Checked: boolean;
	/**è¯¥è¡å³èçä¸»é®å¼ï¼å¤å­æ®µç¨csvæ ¼å¼ç»å */
	Key: string;
	Data: any;
	/**ç»å®è®°å½çå¤çæé®çå¯ç¨æ§ */
	Processes: { [key: string]: IRenderProcess };
}
/**èåé¡¹å®ä¹ä¸­çå¤çæé®çåæ° */
export interface IRecordViewProcess {
	Name: string;
	/**[namespace]:[name] çæ¹å¼*/
	Icon: string;
	/**å¾æ çé¢è² */
	Color: string;
	ElementName: string;
	Element: {
		Name: string;
		Label: string;
		LabelEN: string;
		Category: string;
		CategoryEN: string;
		Icon: string;
		Color: string;
		Controller: string;
		Bill: boolean; // Controlleræ¯å¦æ¯bill
		BillOperate: string; // å¦ææ¯billï¼åå­æ¾add\edit\delete\browseä¹ä¸
		URL: string;
	};
	BindRecord: boolean;
	/**ä¼ éå°ä¸ä¸ä¸ªå·¥ä½åç´ çè·¯å¾ä¸ï¼ä¸è¬ç¨æ¥ä¼ éä¸»é®ï¼å¦æä¸ºç©ºåèªå¨ä¼ éè¡¨çä¸»é®*/
	TransPath: string[];
	/**ä¼ éå°ä¸ä¸ä¸ªå·¥ä½åç´ çåæ°ï¼ç¨æ¨¡æ¿æ¥å®æ,
		ä¸è¬æ¯ç¨æ¥ä¼ éå°å¦ä¸ä¸ªRecordViewçéå æ¡ä»¶åæ é¢ */
	TransQuery: string;
	/**æ¯å¦ä¼ ésql */
	WithSql: boolean;
	/**éç©ºçè¯è®¡ç®å¯è§æ§ï¼ç¨templaterçè¯­æ³*/
	Visable: string;
	/**å¨æä¼ å¥çmoreåæ°ï¼ä»recordviewçqueryä¸­æå*/
	MoreStr: string;
}
export interface IFetchParamResult {
	UniqueField: string[];
	Processes: IRecordViewProcess[];
	ConditionalTemplates: ConditionalTemplate[];
}
export interface IDisplayColumn {
	Name: string;
	Hidden: boolean;
	Order: Order;
}

// æ¾ç¤ºåæè¦æ¸å
export interface IElementViewDigest {
	OwnerBy: OwnerByEnum;
	Owner: string;
	Name: string;
}
